import {DataStatus} from 'platform/components';

import {lazy, Suspense} from 'react';

const DocumentTemplateEditor = lazy(() =>
  import('./DocumentTemplateEditor').then((module) => ({default: module.DocumentTemplateEditor}))
);

export function DocumentTemplateEditorRoute() {
  return (
    <Suspense fallback={<DataStatus isLoading minHeight={60} />}>
      <DocumentTemplateEditor />
    </Suspense>
  );
}
